import PAGES from '../app/data/PagesConstants';

const setupRoutes = (uiManager) => {
  uiManager.addUiRoute('/dashboard', PAGES.DashboardPage.name)
  uiManager.addUiRoute('/circles', PAGES.CirclesListingPage.name)
  uiManager.addUiRoute('/circles/new', PAGES.NewCirclePage.name)
  uiManager.addUiRoute('/circles/:id', PAGES.ShowCirclePage.name)
  uiManager.addUiRoute('/circles/:id/edit', PAGES.EditCirclePage.name)
  uiManager.addUiRoute('/clusters', PAGES.ClustersListingPage.name)
  uiManager.addUiRoute('/clusters/new', PAGES.NewClusterPage.name)
  uiManager.addUiRoute('/clusters/:id', PAGES.ShowClusterPage.name)
  uiManager.addUiRoute('/clusters/:id/edit', PAGES.EditClusterPage.name)
  uiManager.addUiRoute('/states', PAGES.StatesListingPage.name)
  uiManager.addUiRoute('/pincodes', PAGES.PincodesListingPage.name)
  uiManager.addUiRoute('/pincodes/new', PAGES.NewPinCodePage.name)
  uiManager.addUiRoute('/pincodes/:id/edit', PAGES.EditPinCodePage.name)
  uiManager.addUiRoute('/customers', PAGES.CustomersListingPage.name)
  uiManager.addUiRoute('/charging_station_diagnostics', PAGES.ChargingStationDiagnosticsPage.name)
  uiManager.addUiRoute('/charging_station_version_update', PAGES.ChargingStationVersionUpdatePage.name)
  uiManager.addUiRoute('/customers/:id', PAGES.ShowCustomerPage.name)
  uiManager.addUiRoute('/distributors', PAGES.DistributorsListingPage.name)
  uiManager.addUiRoute('/distributors/:id', PAGES.DistributorDetailsPage.name)
  uiManager.addUiRoute('/fleet_owners', PAGES.FleetOwnersListingPage.name)
  uiManager.addUiRoute('/fleet_owners/:id', PAGES.ShowFleetOwnerPage.name)
  uiManager.addUiRoute('/batteries', PAGES.BatteriesListingPage.name)
  uiManager.addUiRoute('/warehouses', PAGES.WarehousesListingPage.name)
  uiManager.addUiRoute('/vehicles', PAGES.VehiclesListingPage.name)
  uiManager.addUiRoute('/vehicle_types', PAGES.VehicleTypesListingPage.name)
  uiManager.addUiRoute('/inspection_items', PAGES.InspectionsItemsPage.name)
  uiManager.addUiRoute('/battery_models', PAGES.BatteryModelsListingPage.name)
  uiManager.addUiRoute('/battery_models/new', PAGES.NewBatteryModelPage.name)
  uiManager.addUiRoute('/battery_models/:id/edit', PAGES.EditBatteryModelPage.name)
  uiManager.addUiRoute('/charging_stations', PAGES.ChargingStationsListingPage.name)
  uiManager.addUiRoute('/earnings', PAGES.EarningsListingPage.name)
  uiManager.addUiRoute('/partner_billings', PAGES.PartnerBillingsListingPage.name)
  uiManager.addUiRoute('/partner_billings/:id', PAGES.PartnerBillingsShowPage.name)
  uiManager.addUiRoute('/partner_billings/:id/date/:date', PAGES.PerDayEarningShowPage.name)
  uiManager.addUiRoute('/electricity/claims', PAGES.ElectricityClaimsListingPage.name)
  uiManager.addUiRoute('/electricity/config', PAGES.ElectricityConfigsListingPage.name)
  uiManager.addUiRoute('/electricity/providers', PAGES.ElectricityServiceProvidersListingPage.name)
  uiManager.addUiRoute('/offers', PAGES.OffersListingPage.name)
  uiManager.addUiRoute('/offers/new', PAGES.NewOfferPage.name)
  uiManager.addUiRoute('/offers/:id/edit', PAGES.EditOfferPage.name)
  uiManager.addUiRoute('/fleet_owners/:fleet_owner_id/lease_offers/new', PAGES.NewLeaseOfferPage.name)
  uiManager.addUiRoute('/fleet_owners/:fleet_owner_id/lease_offers/:id/edit', PAGES.EditLeaseOfferPage.name)
  uiManager.addUiRoute('/fleet_owners/:fleet_owner_id/lease_offers/:id/rollover_configs', PAGES.RolloverConfigsPage.name)
  uiManager.addUiRoute('/fleet_owners/:fleet_owner_id/lease_offers/:id/rollover_configs/new', PAGES.NewRollOverConfigPage.name)
  uiManager.addUiRoute('/fleet_owners/:fleet_owner_id/lease_offers/:id/rollover_configs/:rollover_config_id/edit', PAGES.EditRollOverConfigPage.name)
  uiManager.addUiRoute('/permissions/config', PAGES.PermissionsConfigPage.name)
  uiManager.addUiRoute('/crm/users', PAGES.CrmUsersListingPage.name)
  uiManager.addUiRoute('/crm/users/new', PAGES.NewCrmUserPage.name)
  uiManager.addUiRoute('/crm/users/:id/edit', PAGES.EditCrmUserPage.name)
  uiManager.addUiRoute('/work_orders', PAGES.WorkOrdersListingPage.name)
  uiManager.addUiRoute('/work_orders/:id', PAGES.ShowWorkOrdersPage.name)
  uiManager.addUiRoute('/wallet_transactions', PAGES.WalletTransactionsListingPage.name)
  uiManager.addUiRoute('/schemes', PAGES.SchemesListingPage.name)
  uiManager.addUiRoute('/schemes/new', PAGES.NewSchemePage.name)
  uiManager.addUiRoute('/schemes/:id/edit', PAGES.EditSchemePage.name)
  uiManager.addUiRoute('/security_amounts', PAGES.SecurityAmountsListingPage.name)
  uiManager.addUiRoute('/security_amounts/new', PAGES.NewSecurityAmountPage.name)
  uiManager.addUiRoute('/security_amounts/:id/edit', PAGES.EditSecurityAmountPage.name)
  uiManager.addUiRoute('/addons', PAGES.AddonsListingPage.name)
  uiManager.addUiRoute('/addons/new', PAGES.NewAddonPage.name)
  uiManager.addUiRoute('/addons/:id/edit', PAGES.EditAddonPage.name)
  uiManager.addUiRoute('/service_centers', PAGES.ServiceCentersListingPage.name)
  uiManager.addUiRoute('/service_centers/new', PAGES.NewServiceCenterPage.name)
  uiManager.addUiRoute('/service_centers/:id/edit', PAGES.EditServiceCenterPage.name)
  uiManager.addUiRoute('/service_centers/:id', PAGES.ShowServiceCenterPage.name)
  uiManager.addUiRoute('/reports/general_reports', PAGES.GeneralReportsListingPage.name)
  uiManager.addUiRoute('/offer_addons', PAGES.OfferAddonsListingPage.name)
  uiManager.addUiRoute('/offer_addons/new', PAGES.NewOfferAddonPage.name)
  uiManager.addUiRoute('/offer_addons/:id/edit', PAGES.EditOfferAddonPage.name)
  uiManager.addUiRoute('/categories', PAGES.ComplaintCategoriesListingPage.name)
  uiManager.addUiRoute('/categories/new', PAGES.NewComplaintCategoryPage.name)
  uiManager.addUiRoute('/categories/:id/edit', PAGES.EditComplaintCategoryPage.name)
  uiManager.addUiRoute('/tally_transactions', PAGES.TallyTransactionsListingPage.name)
  uiManager.addUiRoute('/wallet_cashbacks', PAGES.WalletCashbacksListingPage.name)
  uiManager.addUiRoute('/battery_transactions', PAGES.BatteryTransactionsListingPage.name)
  uiManager.addUiRoute('/uploader_histories', PAGES.UploaderHistoryListingPage.name)
  uiManager.addUiRoute('/voltup_id_cards', PAGES.RfidCardsListingPage.name)
  uiManager.addUiRoute('/challans', PAGES.ChallansListingPage.name)
  uiManager.addUiRoute('/upload_files', PAGES.UploadFilesPage.name)
  uiManager.addUiRoute('/rental_bookings', PAGES.RentalBookingsPage.name)
  uiManager.addUiRoute('/rental_customers', PAGES.RentalCustomersPage.name)
  uiManager.addUiRoute('/rental_customers/:id', PAGES.ShowRentalCustomerPage.name)
  uiManager.addUiRoute('/asset_earnings_config', PAGES.AssetEarningsConfigPage.name)
  uiManager.addUiRoute('/bikes', PAGES.BikesListingPage.name)
  uiManager.addUiRoute('/leads', PAGES.LeadsListingPage.name)
  uiManager.addUiRoute('/leads_earning_configs', PAGES.LeadsEarningConfigsPage.name)
  uiManager.addUiRoute('/leads_earning_configs/new', PAGES.NewLeadsEarningConfigsPage.name)
  uiManager.addUiRoute('/leads_earning_configs/:id/edit', PAGES.EditLeadsEarningConfigsPage.name)
  uiManager.addUiRoute('/service_type_mapping', PAGES.ServiceTypeMappingPage.name)
  uiManager.addUiRoute('/service_type_mapping/new', PAGES.NewServiceTypeMappingPage.name)
  uiManager.addUiRoute('/manage_users', PAGES.HeadUsersListingPage.name)
  uiManager.addUiRoute('/manage_users/new', PAGES.NewHeadUserPage.name)
  uiManager.addUiRoute('/manage_users/:id/edit', PAGES.EditHeadUserPage.name)
  uiManager.addUiRoute('/manage_users/:id/map', PAGES.MapHeadUserPage.name)
  uiManager.addUiRoute('/vak', PAGES.VoltUpAllocationKitListingPage.name)
  uiManager.addUiRoute('/vak/new', PAGES.NewVoltUpAllocationKitPage.name)
  uiManager.addUiRoute('/vak/:id/edit', PAGES.EditVoltUpAllocationKitPage.name)
  uiManager.addUiRoute('/vak_reports', PAGES.VoltUpAllocationKitReportsListingPage.name)
  uiManager.addUiRoute('/vak_transactions', PAGES.VoltUpAllocationKitTransactionsListingPage.name)
  uiManager.addUiRoute('/find_user', PAGES.SearchUserPage.name)
  uiManager.addUiRoute('/charging_zone_map', PAGES.ChargingZonesMapPage.name)
  uiManager.addUiRoute('/support', PAGES.SupportPage.name)
  uiManager.addUiRoute('/transaction_orders', PAGES.TransactionOrdersPage.name)
  uiManager.addUiRoute('/service_centers/:service_center_id/technician/:id/edit', PAGES.EditTechnicianPage.name)
  uiManager.addUiRoute('/service_centers/:service_center_id/technician/new', PAGES.NewTechnicianPage.name)
  uiManager.addUiRoute('/service_centers/:service_center_id/dsc_coordinator/new', PAGES.NewCoordinatorPage.name)
  uiManager.addUiRoute('/service_centers/:service_center_id/dsc_coordinator/:id/edit', PAGES.EditCoordinatorPage.name)
  // uiManager.addUiRoute('/operations', PAGES.OperationsPage.name)
}

export default setupRoutes;
